import React from 'react';
import { DataGrid, GridColDef, GridSortModel } from '@mui/x-data-grid';
import { ApiResponse } from '../../../services/api';
import { CargoResponse } from '../../../services/cargoService';

interface CargoTableProps {
  rows: any[];
  columns: GridColDef[];
  width?: string;
  apiResponse: ApiResponse<CargoResponse> | null;
  paginationModel: any;
  setPaginationModel: any;
  sortModel?: GridSortModel;
  onSortModelChange?: (model: GridSortModel) => void;
}

const CargoTablePaginated: React.FC<CargoTableProps> = ({
  apiResponse,
  rows,
  columns,
  width = '100%',
  paginationModel,
  setPaginationModel,
  sortModel,
  onSortModelChange,
}) => {
  return (
    <div style={{ height: '100%', width, display: 'flex', flexDirection: 'column' }}>
      <div style={{ flex: 1, minHeight: 0 }}>
      <DataGrid
        rows={rows}
        columns={columns}
        rowHeight={36}
        columnHeaderHeight={40}
        pageSizeOptions={[10, 20, 40, 100]}
        pagination
        paginationMode='server'
        paginationModel={paginationModel}
        onPaginationModelChange={setPaginationModel}
        rowCount={apiResponse?.data?.totalItems ?? 0}
        sortingMode='server'
        sortModel={sortModel}
        onSortModelChange={onSortModelChange}
        checkboxSelection={false}
        disableRowSelectionOnClick
        getRowClassName={(params) => {
          const fromValue = params.row.fromIdentification;
          const rowIndex = params.indexRelativeToCurrentPage; 

          if (fromValue === 'LAX') {
            return rowIndex % 2 === 0 ? 'highlight-lax-even' : 'highlight-lax-odd';
          }
          if (fromValue === 'CVG') {
            return rowIndex % 2 === 0 ? 'highlight-cvg-even' : 'highlight-cvg-odd';
          }
          if (fromValue === 'DFW') {
            return rowIndex % 2 === 0 ? 'highlight-dfw-even' : 'highlight-dfw-odd';
          }
          if (fromValue === 'MIA') {
            return rowIndex % 2 === 0 ? 'highlight-mia-even' : 'highlight-mia-odd';
          }

          return '';
        }}
        sx={{
          '& .MuiDataGrid-row:nth-of-type(even)': {
            backgroundColor: '#f5f5f5',
          },
          '& .MuiDataGrid-row:nth-of-type(odd)': {
            backgroundColor: 'white',
          },
          '& .MuiDataGrid-row:hover': {
            backgroundColor: '#b2d1ff',
          },
          '& .highlight-lax-even': {
            backgroundColor: '#2600A0 !important',
            color: '#FFFFFF !important',
          },
          '& .highlight-lax-odd': {
            backgroundColor: '#0004B9 !important',
            color: '#FFFFFF !important',
          },

          '& .highlight-cvg-even': {
            backgroundColor: '#89E17E !important',
          },
          '& .highlight-cvg-odd': {
            backgroundColor: '#B1EEB6 !important',
          },
          '& .highlight-dfw-even': {
            backgroundColor: '#fff1c1 !important',
          },
          '& .highlight-dfw-odd': {
            backgroundColor: '#fff7a8 !important',
          },

          '& .highlight-mia-even': {
            backgroundColor: '#C6C3BE !important',
          },
          '& .highlight-mia-odd': {
            backgroundColor: '#FFFCF8 !important',
          },
          '& .MuiTablePagination-selectLabel': {
            marginTop: '14px',
          },
          '& .MuiTablePagination-displayedRows': {
            marginTop: '14px',
          },
          "& .MuiDataGrid-cell[id='id']": {
            cursor: 'pointer !important',
          },
          "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within": {
            outline: "none",
          },
          "& .MuiDataGrid-row:focus, & .MuiDataGrid-row:focus-within": {
            outline: "none",
          }
        }}
      />
      </div>
    </div>
  );
};

export default CargoTablePaginated;
